import { Parcel } from "../../../../services/parcelTypes";
import { toTitleCase } from "../../../../utils/parcelFormatters";
import { Field, safeText } from "../ParcelFields";
import { ParcelSection } from "../ParcelSection";

export function ParcelPropertyDetailsSection({
    parcel,
    isEditing,
}: {
    parcel: Parcel;
    isEditing: boolean;
    
}) {
    return (
        <ParcelSection
            title="Property Details"
            icon={
                <svg fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
                </svg>
            }
            collapsible
            defaultExpanded={true}
            isEditing={isEditing}
            closeWhenEditing
        >
            <Field label="Owner Name" value={toTitleCase(parcel.ownership?.ownerName)} />
            <Field label="Land Use" value={safeText(parcel.landUse?.category)} />
            <Field label="Land Use Description" value={safeText(parcel.landUse?.description)} />
            <Field label="Zoning" value={safeText(parcel.zoning?.code)} />
        </ParcelSection>
    );
}